import React, {Component, PropTypes, cloneElement} from 'react';
import {connect} from 'react-redux';
import {formatPattern} from 'react-router';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {imagesLoaded, pageResized} from './state/images/actions';

import {MasonryGallery} from './components';

async function getData() {
  try {
    const dataUri = process.env.NODE_ENV === 'production' ? '/data' : '/data/redseatestdata.json';
    const response = await fetch(dataUri);

    if (!response.ok) {
      const {url, status, statusText} = response;
      throw new Error(`Error loading ${url}, status: ${status}, ${statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export class AppComponent extends Component {

  static propTypes = {
    imagesLoadedAction: PropTypes.func.isRequired,
    pageResizedAction: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    fastTransition: PropTypes.bool,
    childrenShowing: PropTypes.bool,
    childKey: PropTypes.string
  };

  componentWillMount() {
    getData().then(this.props.imagesLoadedAction);
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  }

  resizeHandler = () => {
    const {pageResizedAction} = this.props;
    pageResizedAction(window.outerWidth);
  };

  render() {
    const {children, childrenShowing, childKey, fastTransition} = this.props;

    const transitionSpeed = fastTransition ? 300 : 600;
    const transitionClass = fastTransition ? 'page-fast' : 'page';

    return (
      <div className="app">

        <MasonryGallery showChildren={childrenShowing} />

        <ReactCSSTransitionGroup
          component="section"
          className="content-container"
          transitionName={transitionClass}
          transitionEnterTimeout={transitionSpeed}
          transitionLeaveTimeout={transitionSpeed}>
          {children ? cloneElement(children, {key: childKey}) : null}
        </ReactCSSTransitionGroup>

      </div>
    );
  }
}

const actionsToBind = {
  imagesLoadedAction: imagesLoaded,
  pageResizedAction: pageResized,
};

const mapStateToProps = ({route: {prevRoute, currentRoute}}, props) => {
  const {location: {pathname}, params} = props;

  const fastTransition = prevRoute !== '/' && currentRoute !== '/';
  const showAbout = pathname === '/about';
  const showGallery = params && params.image ? formatPattern('/gallery/:image', params) === pathname : false;

  return {
    childrenShowing: showAbout || showGallery,
    childKey: showAbout ? 'about' : 'gallery,',
    fastTransition,
  };
};

export const App = connect(mapStateToProps, actionsToBind)(AppComponent);



// WEBPACK FOOTER //
// ./src/App.js